export const FETCH_PROJECTS = '[ Project ] Fetch projects'
export const FETCH_PROJECT = '[ Project ] Fetch project'

export const CLEAR_PROJECT = '[ Project ] Clear project state'
export const CREATE_PROJECT = '[ Project ] Create new project'
export const UPDATE_PROJECT = '[ Project ] Update project'

export const CREATE_PROJECT_POST = '[ Project ] Create post'
export const DELETE_PROJECT_POST = '[ Project ] Delete post'
export const UPDATE_PROJECT_POST = '[ Project ] Update post'

export const FETCH_PROJECT_POSTS = '[ Project ] Fetch posts'
